import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/home'),
      meta: {
        nav: '',
        nokeep: true
      }
    },
    {
      path: '/en',
      name: 'en',
      component: () => import('@/pages/home'),
      meta: {
        nav: '',
        nokeep: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/pages/profile'),
      meta: {
        nav: 'dahui'
      }
    },
    {
      path: '/wangjie',
      name: 'wangjie',
      component: () => import('@/pages/wangjie'),
      meta: {
        nav: 'dahui'
      }
    },
    {
      path: '/forum',
      name: 'forum',
      component: () => import('@/pages/forum'),
      meta: {
        nav: 'dahui'
      }
    },
    {
      path: '/zhanqu',
      name: 'zhanqu',
      component: () => import('@/pages/zhanqu'),
      meta: {
        nav: 'dahui',
        num: 1
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/pages/activity'),
      meta: {
        nav: 'dahui'
      }
    },
    {
      path: '/yingyong',
      name: 'yingyong',
      component: () => import('@/pages/yingyong'),
      meta: {
        nav: 'dahui'
      }
    },
    {
      path: '/zixun',
      name: 'zixun',
      component: () => import('@/pages/zixun'),
      meta: {
        nav: 'zixun',
        num: 5
      }
    },
    {
      path: '/fabu',
      name: 'fabu',
      component: () => import('@/pages/fabu'),
      meta: {
        nav: 'zixun'
      }
    },
    {
      path: '/chuangjian',
      name: 'chuangjian',
      component: () => import('@/pages/chuangjian'),
      meta: {
        nav: 'chuangjian',
        num: 3
      }
    },
    {
      path: '/fuwu',
      name: 'fuwu',
      component: () => import('@/pages/fuwu'),
      meta: {
        nav: '',
        num: 5
      }
    },
    {
      path: '/juzheng',
      name: 'juzheng',
      component: () => import('@/pages/juzheng'),
      meta: {
        nav: 'juzheng',
        num: 2
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login'),
      meta: {
        nav: '',
        noHead: true,
        noFoot: true
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/pages/search'),
      meta: {
        nav: '',
        noHead: true,
        noFoot: true
      }
    },
    {
      path: '/cjdetail',
      name: 'cjdetail',
      component: () => import('@/pages/cjdetail'),
      meta: {
        nav: '',
      }
    },
    {
      path: '/zbdetail',
      name: 'zbdetail',
      component: () => import('@/pages/zbdetail'),
      meta: {
        nav: '',
      }
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('@/pages/apply'),
      meta: {
        nav: '',
      }
    },
    {
      path: '/countdown_live',
      name: 'countdown_live',
      component: () => import('@/pages/countdown_live'),
      meta: {
        nav: '',
      }
    },
    {
      path: '/countdown_live2024',
      name: 'countdown_live2024',
      component: () => import('@/pages/countdown_live2024'),
      meta: {
        nav: '',
      }
    },
  ]
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js